import styled from 'styled-components';

export const MRDContactManagementStyles = styled.div`
  .fkTuFL .rt-tbody .rt-td{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .add-mrd-container-buttons{
      margin: 10px 30px;
      min-width: 940px;
    }
  .mrd-contacts {
      width: 60%;
      margin-left: 20%;
   }
  .mrd-contact-button{
    margin-left: 5px;
  }
  .mrd-contact-button-container{
    margin: 30px 0 -38px 45px;
    z-index: 99;
    position: relative;
    width: 510px;
  }

  @media only screen and (max-width:1899px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 553px;
    }
  }
  @media only screen and (min-width:1900px) and (max-width:1915px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 665px;
    }
  }

  @media only screen and (min-width:1916px) and (max-width:2135px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 665px;
    }
  }

  @media only screen and (min-width:2136px) and (max-width:2200px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 765px;
    }
  }

  @media only screen and (min-width:2201px) and (max-width:2400px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 875px;
    }
  }

  @media only screen and (min-width:2401px) and (max-width:2800px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 985px;
    }
  }

  @media only screen and (min-width:2801px) and (max-width:2900px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1095px;
    }
  }

  @media only screen and (min-width:2901px) and (max-width:3200px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1195px;
    }
  }

  @media only screen and (min-width:3201px) and (max-width:3900px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 1500px;
    }
  }

  @media only screen and (min-width:3901px){
    .generated-list {
      padding-bottom: 10px !important;
    }
    .fkTuFL {
      max-height: 2410px;
    }
`;
